import { CmsFooterSitemapProperties } from '../Models/CmsFooterContactsProperties';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NgModule } from '@angular/core';
import { HttpEventType, HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { CMSService } from '../Services/cms.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-cms-sub-fsitemap',
  templateUrl: './cms-sub-fsitemap.component.html',
  styleUrls: ['./cms-sub-fsitemap.component.css']
})
@NgModule({ imports: [FormsModule] })
export class CmsSubFSitemapComponent {
  fSitemapObj = new CmsFooterSitemapProperties();
  public responseMessage: string;
  constructor(private userService: CMSService, public cmsService: CMSService, private http: HttpClient) { };
  ngOnInit() {
    this.LoadEditableData();
  }
  LoadEditableData() {
    try {
      if (localStorage.getItem("serialNo") != undefined || localStorage.getItem("serialNo") != null) {
        let sr = Number(localStorage.getItem("serialNo"));
        if (sr != 0 || sr != undefined) {
          this.userService.getFooterSitemapById(sr).subscribe((data) => {
            this.fSitemapObj = data[0] as CmsFooterSitemapProperties;
            localStorage.removeItem("serialNo");
          });
        }
      }
    }
    catch (e) {
      //console.log(e);
    }
  }
  onSubmit() {
    if (this.fSitemapObj.sr == 0 || this.fSitemapObj.sr ==null) {
      this.userService.createFooterSitemap(this.fSitemapObj).subscribe((data => {
        if (data === true) {
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "Data inserted Successfully :)"
          $("#response-screen").delay(5000).hide(1000);
        }
        else {
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "Error occured while inserting data :("
          $("#response-screen").delay(5000).hide(1000);
        }
      }));
    } else {
      this.userService.updateFooterSitmap(this.fSitemapObj).subscribe((data => {
        if (data === true) {
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "Data updated Successfully :)"
          $("#response-screen").delay(5000).hide(1000);
        }
        else {
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "Error occured while updating data :("
          $("#response-screen").delay(5000).hide(1000);
        }
      }));
    }
  }
  cancel() {
    this.fSitemapObj = new CmsFooterSitemapProperties();
  }
}
